export var borderColor = 'var(--_1jljrbf1-3-8-0)';
export var rangeColor = 'var(--_1jljrbf0-3-8-0)';